import React from "react";
import DatePicker from "../../core/components/DatePicker";
import {useTranslation} from "react-i18next";
import DeviceSelectBox from "../device/DeviceSelectBox";

const {RangePicker} = DatePicker;

export default function AppointmentSchedulerFilter({deviceId, setDeviceId, dateRange, setDateRange})
{
    const {t} = useTranslation();

    return (
        <div style={{display: 'flex', gap: '16px', alignItems: 'flex-end'}}>
            <div style={{flex: 1}}>
                <label style={{display: 'block', marginBottom: 8, fontWeight: 'bold'}}>
                    {t('Device')}
                </label>
                <DeviceSelectBox 
                    value={deviceId}
                    onChange={setDeviceId}
                    style={{width: '100%'}}
                />
            </div>

            {/* <div style={{flex: 1}}>
                <label style={{display: 'block', marginBottom: 8, fontWeight: 'bold'}}>
                    {t('DateRange')}
                </label>
                <RangePicker
                    value={dateRange}
                    onChange={setDateRange}
                    format="DD.MM.YYYY"
                    style={{width: '100%'}}
                />
            </div> */}
        </div>
    )
}
